import axios from 'axios';

const FILE_API_BASE_URL = 'https://cs.fabbuilder.com/api';

export const fileApi = {
  getDownloadUrl: async (tenantId: string, privateUrl: string) => {
    const response = await axios.get(
      `${FILE_API_BASE_URL}/tenant/${tenantId}/file/download-url`,
      { params: { privateUrl } },
    );
    return response.data;
  },
};
